import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import moment from "moment";
import { mapGetters } from "vuex";
// import userAccess from "@/foundations/user/mixins/userAccess.js";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import getData from "@/data/cloud/firebase/mixins/getData.js";
import getList from "@/data/cloud/firebase/mixins/getList.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import adminFunctions from "@/admin/functions/mixins/adminFunctions.js";

export default {
  data() {
    return {
      email: "",
      password: "",
      message: "sign in"
    };
  },
  mixins: [
    announcements,
    dataSources,
    getData,
    getList,
    storeFunctions,
    adminFunctions
  ],
  computed: {
    ...mapGetters(["getUser", "getDataPrivacy"])
  },
  methods: {
    validate() {
      if (this.$refs.form.validate() === true) {
        this.enableBtnSpinSignin = true; // enable spin button disable validation
        // Define User
        const email = this.email;
        const password = this.password;

        // Reference DB
        const db = firebase.firestore();
        const t = this;
        // FIREBASE SIGN IN
        // eslint-disable-next-line
        firebase.auth().signInWithEmailAndPassword(email, password)
          // eslint-disable-next-line
          .then(firebaseUser => {
            // IF USER SIGN EMAIL IS NOT VERFIFED
            if (firebaseUser.user.emailVerified === false) {
              // eslint-disable-next-line
              t.message = "Email is not verified, please check your email account inbox or junk email and follow the link from Besea Team."
            }
            // check that account was email emailVerified
            if (firebaseUser.user.emailVerified === true) {
              // FIREBASE SEARCH USER
              let userDID = null;
              db.collection("user")
                // eslint-disable-next-line
                .where("basic.uid", "==", firebaseUser.user.uid).get()
                .then(querySnapshot => {
                  querySnapshot.forEach(doc => {
                    userDID = doc.data().basic.did;
                    // COMPARE USER UID
                    // eslint-disable-next-line
                    db.collection("stats").doc(userDID).update({
                        // eslint-disable-next-line
                        'stats.dsin': moment().format(),
                        // eslint-disable-next-line
                        'stats.dchk': moment().format()
                      })
                      // eslint-disable-next-line
                      .then(data => {
                        // GET Data Privacy
                        this.getDocumentDirect("Z1", "current");
                        // GET Terms and Conditions
                        this.getDocumentDirect("Z2", "current");
                        // GET Comms
                        this.getDocumentDirect("Z7", "message");
                        // GET Licence
                        this.getDocumentDirect("Z10", "current");
                        // GET Company Access Limit
                        if (doc.data().pref.select.cauth !== null) {
                          let cdid = doc.data().pref.select.cdid;
                          this.getDocumentCompanyAccessOnly(cdid);
                        }
                        // eslint-disable-next-line
                        db.collection("stats").doc(userDID).get().then(doc => {
                            this.$store.dispatch("changeUserStats", doc.data());
                          });
                        // 3. get user updated data
                        // eslint-disable-next-line
                        db.collection("user").doc(userDID).get()
                          .then(doc => {
                            // GET Facility Access Limit
                            // This seperartion is needed
                            if (doc.data().pref.select.fauth !== null) {
                              let fdid = doc.data().pref.select.fdid;
                              this.getDocumentFacilityAccessOnly(fdid);
                            }
                            // SAVE USER TO STORE
                            this.userSaveStore(doc.data());
                            // user sign in
                            // GO TO PAGE
                            // eslint-disable-next-line
                            let pagesignin = doc.data().pref.page.signin;
                            this.$router.push(pagesignin);
                            this.enableBtnSpinSignin = false;
                          });
                      });
                  });
                });
            } else {
              let m = "Check your email inbox to verify the besea account.";
              t.enableBtnSpinSignin = false;
              t.showSnackbar(m, "error");
            }
          })
          .catch(function(error) {
            // NOT WORKING ???
            t.enableBtnSpinSignin = false;
            t.message = error.message;
          });
      }
    },
    userSaveStore(user) {
      // user.basic.act = this.checkUserOK(user.basic);
      // Update User Store
      this.$store.dispatch("changeUser", user);
      // // start user store
      this.saveToStore(user);
      // this.startUserStore();
      // GET User Access
      this.getUserAccess();
      // Reset store
      this.resetStore();
      // console.log("USER SIGN IN");
      // console.log(user);
    }
  }
};
